<template>
  <div class="pt-6 pb-4" :style="style" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GGAppHeader',
  props: {
    fontSize: {
      required: false,
      type: String,
      default: '1.00rem',
    },
    fontWeight: {
      required: false,
      type: Number,
      default: 500,
    },
    letterSpacing: {
      required: false,
      type: String,
      default: '0.0125em',
    },
    lineHeight: {
      required: false,
      type: String,
      default: '1.65rem',
    },
    wordBreak: {
      required: false,
      type: String,
      default: 'break-all',
    },
  },
  data () {
    return {
      style: {
        fontSize: this.fontSize,
        fontWeight: this.fontWeight,
        letterSpacing: this.letterSpacing,
        lineHeight: this.lineHeight,
        wordBreak: this.wordBreak,
      }
    }
  }
}
</script>
<style>
.custom {
}
</style>
